import React from 'react';
import { IProduct } from '../../../Types/product';
import {
  Card,
  CardActionArea,
  CardContent,
  Typography,
} from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';
import CustomTooltip from '../../BuildingBlocks/Tooltip/Tooltip';

const useStyles = makeStyles((theme) => ({
  card: {
    width: 225,
    marginLeft: theme.spacing(0.25),
    marginRight: theme.spacing(0.25),
  },
  cardContainer: { height: '100%' },
  asin: {
    fontWeight: 'bold',
    direction: 'rtl',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },
  name: { fontWeight: 'bold' },
  img: { maxHeight: 100, maxWidth: 200, marginBottom: theme.spacing(2) },
  selected: { border: '3px solid ' + theme.palette.primary.main },
}));

export default function ProductCard({
  product,
  index,
  isSelected,
  onSelect,
}: {
  product: IProduct;
  index: number;
  isSelected: boolean;
  onSelect: (id: string) => void;
}) {
  const classes = useStyles();

  return (
    <Card
      key={`${product.id}-${index}`}
      className={classes.card + ' ' + (isSelected ? classes.selected : '')}
    >
      <CardActionArea
        className={classes.cardContainer}
        onClick={() => {
          onSelect(product.id);
        }}
      >
        <CardContent className={classes.cardContainer}>
          <Typography paragraph className={classes.asin}>
            {product.asin}
          </Typography>
          {product.image && (
            <img
              src={product.image}
              alt="product logo"
              className={classes.img}
            />
          )}
          <Typography className={classes.name}>
            {product.name?.length > 40 ? (
              <CustomTooltip
                arrow
                title={<Typography>{product.name}</Typography>}
                placement="top"
              >
                <div>{product.name.slice(0, 40) + '...'}</div>
              </CustomTooltip>
            ) : (
              product.name
            )}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
